import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../services/api/base';

export const useBusinessSettings = (namespace) => {
  const [settings, setSettings] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const loadSettings = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await apiClient.get(`/business-settings/${namespace}`);
      setSettings(response.data.settings || {});
    } catch (error) {
      console.error(`Failed to load business settings for ${namespace}:`, error);
    } finally {
      setIsLoading(false);
    }
  }, [namespace]);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  // Keeps other mounted consumers of the same namespace (e.g. the Sidebar) in sync after a save.
  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.namespace === namespace) setSettings(e.detail.settings || {});
    };
    window.addEventListener('businessSettingsChanged', handler);
    return () => window.removeEventListener('businessSettingsChanged', handler);
  }, [namespace]);

  const saveSettings = async (newSettings) => {
    const response = await apiClient.put(`/business-settings/${namespace}`, { settings: newSettings });
    const saved = response.data.settings || newSettings;
    setSettings(saved);
    window.dispatchEvent(new CustomEvent('businessSettingsChanged', { detail: { namespace, settings: saved } }));
    return response.data.settings;
  };

  return { settings, isLoading, saveSettings, reload: loadSettings };
};
